import { render, staticRenderFns } from "./museumItem.vue?vue&type=template&id=0ce56ef9&scoped=true&"
import script from "./museumItem.vue?vue&type=script&lang=js&"
export * from "./museumItem.vue?vue&type=script&lang=js&"
import style0 from "./museumItem.vue?vue&type=style&index=0&id=0ce56ef9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce56ef9",
  null
  
)

export default component.exports